const featureDE = {
    "view": {
        "table": {
            "title": "Feature-Anfragen",
            "column": {
                "release_name": "Name",
                "release_artist_name": "Name des Künstlers",
                "release_date": "Veröffentlichungsdatum",
                "exclusive_date": "Exklusivdatum"
            },
            "button": {
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    },
    "add": {
        "title": "Marketing-Fakten",
        "form": {
            "label": {
                "release": "Veröffentlichung",
                "djTastemaker": "DJ / TasteMaker Feedbacks:",
                "radioSupport": "Radio-Unterstützung",
                "marketingPR": "Marketing / PR",
                "labelReach": "Reichweite von Label und Künstlern:"
            },
            "help_text": {
                "release": "Wählen Sie eine Veröffentlichung aus, für die Sie eine Feature-Anfrage einreichen möchten. Sie können nur Veröffentlichungen sehen und auswählen, die ein allgemeines Veröffentlichungsdatum 22 oder mehr Tage im Voraus haben. Wenn Sie ein exklusives Veröffentlichungsdatum anstreben, stellen Sie bitte sicher, dass Sie dieses Formular mindestens 22 Tage vor einem (ersten) exklusiven Veröffentlichungsdatum einreichen.",
                "djTastemaker": "Fügen Sie 10 DJ / Radio / Magazin-Feedbacks im Format 'Name - Feedback' ein (Fügen Sie jedes Feedback in eine Zeile ein). Einsendungen, die 'downloading for' enthalten, werden nicht beworben oder an Online-Shops gesendet.",
                "radioSupport": "Wird Ihr Song oder eine Veröffentlichung bei einigen Radiosendern gespielt? Wenn ja, nennen Sie den Sender und fügen Sie den entsprechenden Link zu ihrer Seite ein, auf der sichtbar ist, dass sie Ihre Songs bewerben oder spielen.",
                "marketingPR": "(Interviews, Blogs, Rezensionen, Magazinartikel) - Bitte listen Sie alle zugesagten Presse- und Marketingaktivitäten für diese Veröffentlichung auf. Nicht obligatorisch, aber wesentlich wichtig, um sich von der Konkurrenz abzuheben.",
                "labelReach": "Die kombinierte (Label und Künstler) Anzahl der Follower auf Facebook, Instagram, SoundCloud und YouTube. <strong>Bitte geben Sie jede Plattform und die Anzahl der Follower in einer neuen Zeile an</strong>."
            },
            "button": {
                "submit": "Einreichen"
            },
            "message": {
                "releaseRequired": "Vorhandene Veröffentlichung ist erforderlich",
                "featureRequestAlreadyExists": "Feature-Anfrage für diese Veröffentlichung wurde bereits gestellt"
            }
        },
        "message": {
            "success": "Feature-Anfrage wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "confirm": {
                "header": "Neue Feature-Anfrage",
                "body": "Diese Feature-Anfrage muss mindestens 21 Tage vor dem ersten (exklusiven oder allgemeinen, je nachdem, was zuerst kommt) Datum eingereicht werden. Leider können verspätete Einreichungen nicht berücksichtigt werden. Möchten Sie Ihre Feature-Anfrage einreichen?"
            }
        }
    }
};

export default featureDE;